import * as React from "react";
import Direction from "@/components/atomics/direction";
import { QuestType } from "@/types/quests";

interface QuestTabsProps {
  selectedTab: QuestType;
  onTabChange: (tab: QuestType) => void;
}

export default function QuestTabs({
  selectedTab,
  onTabChange,
}: QuestTabsProps) {
  const tabs: { id: QuestType; label: string[]; disabled?: boolean }[] = [
    { id: "daily", label: ["DAILY"], disabled: true },
    { id: "weekly", label: ["WEEKLY"], disabled: true },
    { id: "unique", label: ["UNIQUE"] },
  ];

  return (
    <div className="flex flex-col justify-center items-center px-8">
      <div className="w-full flex justify-between items-center gap-x-7 text-[18px] mb-8">
        {tabs.map(({ id, label, disabled }) => (
          <div
            key={id}
            className={`relative flex flex-col items-center transition-colors ${
              disabled
                ? "cursor-not-allowed opacity-40"
                : "cursor-pointer"
            } ${
              selectedTab === id && !disabled ? "--blue" : "text-white"
            }`}
            onClick={() => !disabled && onTabChange(id)}
          >
            {label.map((text, index) => (
              <span key={index}>{text}</span>
            ))}
            {selectedTab === id && !disabled && (
              <div className="absolute top-[-22px]">
                <Direction
                  className="w-[11px] h-[19px] rotate-90"
                  color="#0099FE"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
